import React, { useEffect, useState } from "react";
import LogoMark from "../../gallery/default/logomark.png";
import axios from "axios";
import { useDispatch } from "react-redux";
import { setUser, setSignup } from "../../app/features/user/userSlice";
import { BeatLoader } from "react-spinners";
import { Modal } from "bootstrap";

function LoginForm() {
  const dispatch = useDispatch();

  const [passwordError, setPasswordError] = useState(null);
  const [emailError, setEmailError] = useState(null);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  useEffect(() => {
    setTimeout(() => {
      var emailInput = document.querySelector('input[name="email"]');
      var passwordInput = document.querySelector('input[name="password"]');
      var email = (emailInput && emailInput.value ? emailInput.value.trim() : "") || "";
      var password = (passwordInput && passwordInput.value ? passwordInput.value.trim() : "") || "";

      if (email || password) {
        setFormData({ email, password });
      }
    }, 500);
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const login = async (event) => {
    event.preventDefault();
    const loginButton = event.target;
    loginButton.classList.remove("btn-login");
    loginButton.classList.add("btn-disable-login");
    const loader = document.getElementById("loginLoader");
    loader.style.display = "block";

    const email = document.querySelector('input[name="email"]').value.trim();
    const password = document.querySelector('input[name="password"]').value.trim();

    if (!isValidEmail(email)) {
      setEmailError("Please enter a valid email!");
      resetButton(loginButton, loader);
      return;
    }
    if (password.length < 6) {
      setPasswordError("Password must be at least 6 characters!");
      resetButton(loginButton, loader);
      return;
    }

    try {
      await axios.get(`${process.env.REACT_APP_BASE_URL}/api/sanctum/csrf-cookie`);

      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/login`, {
        email,
        password,
      });

      const userData = response.data.data;
      if (userData.name) {
        const nameParts = userData.name.trim().split(" ");
        userData.first_name = nameParts[0];
        userData.last_name = nameParts.slice(1).join(" ");
      }

      loader.style.display = "none";

      const authModal = new Modal(document.getElementById("authModal"));
      authModal.hide();

      setTimeout(() => {
        document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
        document.body.classList.remove("modal-open");
        document.body.style.removeProperty("overflow");
        document.body.style.removeProperty("padding-right");

        dispatch(setUser(userData));
         window.location.href = `${process.env.REACT_APP_BASE_URL}/home`;

      }, 400);
    } catch (error) {
      console.log("Here is the Error", error);
      setEmailError((error.response && error.response.data && error.response.data.message) || "Login failed");
      resetButton(loginButton, loader);
    }
  };

  const resetButton = (button, loader) => {
    loader.style.display = "none";
    button.classList.remove("btn-disable-login");
    button.classList.add("btn-login");
    setTimeout(() => {
      setEmailError(null);
      setPasswordError(null);
    }, 4000);
  };

  const goToSignup = (event) => {
    event.preventDefault();
    dispatch(setSignup());
  };

  return (
    <div className="login-container">
      <div className="row">
        <div className="col-12">
          <div className="col-12 d-flex justify-content-center mb-4">
            <img src={LogoMark} alt="Sahi Search" />
          </div>
          <h3 className="login-sub-heading mb-2">Login</h3>

          <form className="row g-3" autoComplete="on">
            <div className="col-12">
              <label htmlFor="staticEmail2" className="form-label input-label">
                Email
              </label>
              <input type="email" className={`form-control input-text-size ${emailError ? "error-input" : ""}`} placeholder="Enter your email" name="email" value={formData.email} onChange={handleChange} />
              {emailError && <p className="error-text mb-0">{emailError}</p>}
            </div>

            <div className="col-12">
              <label htmlFor="inputPassword2" className="form-label input-label">
                Password
              </label>
              <input type="password" className={`form-control input-text-size ${passwordError ? "error-input" : ""}`} name="password" placeholder="Enter your password" value={formData.password} onChange={handleChange} />
              {passwordError && <p className="error-text mb-0">{passwordError}</p>}
            </div>

            <div className="col-12 text-center mt-4">
              <button id="logindefaultbtn" type="button" className={emailError || passwordError ? "btn btn-disable-login mb-3" : "btn btn-login mb-3"} onClick={login}>
                Sign in
              </button>
              <div id="loginLoader" style={{ display: "none" }}>
                <BeatLoader color="#C6153B" />
              </div>
            </div>

            <div className="col-12">
              <p className="account">
                Don't have an account?{" "}
                <span>
                  <a href="/" className="sign-up" onClick={goToSignup}>
                    Sign up
                  </a>
                </span>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default LoginForm;
